module.exports = __webpack_public_path__ + "img/ke.3dfd2434.svg";